import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdminUserResponse, AuthResponse } from "reduxStore/dataTypes";

interface AdminUserState {
  adminUser: AdminUserResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: AdminUserState = {
  adminUser: null,
  loading: false,
  error: null,
};

const adminUserSlice = createSlice({
  name: "adminUser",
  initialState,
  reducers: {
    adminUserRequest(state) {
      state.loading = true;
      state.error = null;
    },
    adminUserSuccess(state, action: PayloadAction<AdminUserResponse>) {
      state.loading = false;
      state.adminUser = action.payload;
    },
    adminUserFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { adminUserRequest, adminUserSuccess, adminUserFailure } =
  adminUserSlice.actions;
export default adminUserSlice.reducer;
